import styled from 'styled-components';

import colors from '../../../../../../../styles/colors';

const ProgramInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${colors.shades.secondary7};
  margin-bottom: 12px;
  width: 100%;
`;

const ProgramItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px;
  border-radius: 4px;
`;

const ProgramName = styled.div`
  font-weight: 600;
  font-size: 14px;
  color: ${colors.shades.secondary8};
`;

const ProgramDateRange = styled.div`
  font-size: 12px;
  color: ${colors.gamma2};
`;

export {
  ProgramInfoContainer,
  ProgramItem,
  ProgramName,
  ProgramDateRange,
};
